
import {  applyMiddleware } from 'redux';
import { legacy_createStore as createStore} from 'redux'
import thunk from 'redux-thunk';
import exampleReducer from './Reducers/ReduxReducers';

const store = createStore(exampleReducer, applyMiddleware(thunk));

export default store;